/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Patient API
 * API for Patient
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const GetInterviewResponseTypename = "GetInterviewResponse" as const;

/**
 *
 * @export
 * @interface GetInterviewResponse
 */
export interface GetInterviewResponse {
  /**
   *
   * @type {Date}
   * @memberof GetInterviewResponse
   */
  answeredTime?: string;
  /**
   *
   * @type {string}
   * @memberof GetInterviewResponse
   */
  interviewsType: GetInterviewResponseInterviewsTypeEnum;
  /**
   *
   * @type {Date}
   * @memberof GetInterviewResponse
   */
  lastConfirmedTime?: string;
  /**
   *
   * @type {number}
   * @memberof GetInterviewResponse
   */
  patientId: number;
  /**
   * Keys except key 'questionnaires' are for custom use only
   * @type {object}
   * @memberof GetInterviewResponse
   */
  questionnaires: object;
  /**
   *
   * @type {number}
   * @memberof GetInterviewResponse
   */
  version?: number;
  /**
   * Resource type name
   * @type {string}
   * @memberof GetInterviewResponse
   */
  readonly __typename?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum GetInterviewResponseInterviewsTypeEnum {
  Default = "default",
  Custom = "custom",
  Unused = "unused",
}

export function GetInterviewResponseFromJSON(json: any): GetInterviewResponse {
  return GetInterviewResponseFromJSONTyped(json, false);
}

export function GetInterviewResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetInterviewResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: GetInterviewResponseTypename,

    answeredTime:
      !exists(json, "answered_time") ||
      (typeof json["answered_time"] === "string" && json["answered_time"].substring(0, 4) === "0001")
        ? undefined
        : json["answered_time"],
    interviewsType: json["interviews_type"],
    lastConfirmedTime:
      !exists(json, "last_confirmed_time") ||
      (typeof json["last_confirmed_time"] === "string" && json["last_confirmed_time"].substring(0, 4) === "0001")
        ? undefined
        : json["last_confirmed_time"],
    patientId: json["patient_id"],
    questionnaires: json["questionnaires"],
    version: !exists(json, "version") ? undefined : json["version"],
  };
}

export function GetInterviewResponseToJSON(object?: GetInterviewResponse | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    answered_time: value.answeredTime === undefined ? undefined : tzDate(value.answeredTime).format(),
    interviews_type: value.interviewsType,
    last_confirmed_time: value.lastConfirmedTime === undefined ? undefined : tzDate(value.lastConfirmedTime).format(),
    patient_id: value.patientId,
    questionnaires: value.questionnaires,
    version: value.version,
  };
}
